export default angular.module('FrontRoyal.LearnerProjects', []);
